import { createBrowserRouter } from "react-router";
import App from "../../routes/App";
import Dashboard from "../../routes/Dashboard";
import Gestion from "../../routes/_gestion";
import GestionDashboard from "../../routes/_gestion/_dashboard";
import GestionProduits from "../../routes/_gestion/_produits";
import GestionVentes from "../../routes/_gestion/_ventes";
import GestionAjouterProduit from "../../routes/_gestion/_produits/_ajouter_produit";
import OuvrirVente from "../../routes/_gestion/_ventes/_ouvrir_vente";
import SupprimerVente from "../../routes/_gestion/_ventes/_delete_vente";
import AjouterCommande from "../../routes/_ajouter_commande";
//import PanierCommandes from "../../routes/_panier_commandes";
import GestionModifierProduit from "../../routes/_gestion/_produits/_ modifier_produit";
import GestionSupprimerProduit from "../../routes/_gestion/_produits/_supprimer_produit";

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{
				index: true,
				element: <Dashboard />,
			},
			{
				path: "ajouter_commande/:id",
				element: <AjouterCommande />,
			},
			{
				path: "mon_panier",
				element: "<PanierCommandes />",
			},
			{
				path: "gestion",
				element: <Gestion />,
				children: [
					{
						index: true,
						element: <GestionDashboard />,
					},
					{
						path: "produits",
						element: <GestionProduits />,
						children: [
							{
								path: "ajouter_produit",
								element: <GestionAjouterProduit />,
							},
							{
								path: "modifier_produit/:id",
								element: <GestionModifierProduit />,
							},
							{
								path: "supprimer_produit/:id",
								element: <GestionSupprimerProduit />,
							},
						],
					},
					{
						path: "ventes",
						element: <GestionVentes />,
						children: [
							{
								path: "ouvrir_vente",
								element: <OuvrirVente />,
							},
							{
								path: "supprimer_vente/:id",
								element: <SupprimerVente />,
							},
							{
								path: "modifier_vente/:id",
								element: "Modifier Vente",
							},
						],
					},
				],
			},
		],
	},
]);

export default router;
